// Source: app/scripts/app.js
/**
 * @ngdoc Definition of the application module. The first argument is the name
 *        of the module. It is used in the ng-app directive to expose the
 *        angular components that can be used. The second argument is an array
 *        that defines the dependencies (modules) that are used by the
 *        application. In this case we are only use the ngRoute module as a
 *        dependency in order to provide partial content inclusion through the
 *        routes
 * @see router.js for more information
 * @name avAngularStartupApp - the name of the module used in the ng-app
 *       directive
 * @description # avAngularStartupApp Main module of the application.
 */
var Auction = angular.module('eAuction', ['ngResource', 'ngRoute',
  'ngAnimate', 'ngTable', 'ngCookies', 'chieffancypants.loadingBar',
  'ui.select2', 'mgcrea.ngStrap', 'toaster', 'angularFileUpload',
  'pascalprecht.translate', 'ngQuickDate', 'ui.calendar', 'textAngular',
  'angular-carousel'
]);

Auction.config([
  '$provide',
  '$translateProvider',
  '$httpProvider',
  'settings',
  'ngQuickDateDefaultsProvider',
  function ($provide, $translateProvider, $httpProvider, settings,
            ngQuickDateDefaultsProvider) {

    $provide.decorator('taOptions', ['$delegate', function (taOptions) {
      // $delegate is the taOptions we are decorating
      // here we override the default toolbars and classes specified in taOptions.
      taOptions.toolbar = [
        ['pre', 'quote', 'ul', 'ol'],
        ['bold', 'italics', 'underline'],
        ['justifyLeft', 'justifyCenter', 'justifyRight']
      ];
      taOptions.classes = {
        focussed: 'focussed',
        toolbar: 'btn-toolbar',
        toolbarGroup: 'btn-group',
        toolbarButton: 'btn btn-default',
        toolbarButtonActive: 'active',
        disabled: 'disabled',
        textEditor: 'form-control top-buffer',
        htmlEditor: 'top-buffer'
      };
      return taOptions; // whatever you return will be the taOptions
    }]);

    ngQuickDateDefaultsProvider.set({
      closeButtonHtml: "<i class='fa fa-times'></i>",
      buttonIconHtml: "<i class='fa fa-clock-o'></i>",
      nextLinkHtml: "<i class='fa fa-chevron-right'></i>",
      prevLinkHtml: "<i class='fa fa-chevron-left'></i>",
      parseDateFunction: function (str) {
        if (str instanceof Date) {
          if (isNaN(str.getTime())) {
            return null;
          }
          var dateYear = str.getFullYear();
          if (dateYear < (settings.dateMinYear || 1900) || dateYear > (settings.dateMaxYear || 2100)) {
            return null;
          }
          return str;
        }
        if (str == null || String(str).trim() === '') {
          return null;
        }
        str = String(str).trim();
        var typedYearMatch = str.match(/^(\d{1,2})[.\-\/](\d{1,2})[.\-\/](\d{4})(?:\s|$)/)
          || str.match(/^(\d{4})[.\-\/](\d{1,2})[.\-\/](\d{1,2})/);
        if (typedYearMatch) {
          var typedYear = parseInt(typedYearMatch[3] && typedYearMatch[3].length === 4
            ? typedYearMatch[3] : typedYearMatch[1], 10);
          if (typedYear < (settings.dateMinYear || 1900) || typedYear > (settings.dateMaxYear || 2100)) {
            return null;
          }
        }
        var formats = (settings.dateParseFormats || []).concat(settings.dateFormats || []);
        var parsed = moment(str, formats, true);
        if (!parsed.isValid()) {
          parsed = moment(str, moment.ISO_8601, true);
        }
        if (!parsed.isValid()) {
          parsed = moment(str, formats);
        }
        if (!parsed.isValid()) {
          return null;
        }
        if (parsed.year() < (settings.dateMinYear || 1900) || parsed.year() > (settings.dateMaxYear || 2100)) {
          return null;
        }
        return parsed.toDate();
      }
    });
    // Initialize angular-translate
    $translateProvider.useStaticFilesLoader({
      prefix: 'i18n/',
      suffix: '.json'
    });

    $translateProvider.preferredLanguage(settings.language);

    $translateProvider.useCookieStorage();
    $httpProvider.interceptors.push('HRHttpInterceptors');

    Date.prototype.toJSON = function () {
      return moment(this).format(settings.dateTimeFormat);
    };

    Date.prototype.toISOString = function () {
      return moment(this).format(settings.dateTimeFormat);
    };
  }
]);


Auction.run([
  '$rootScope',
  '$location',
  '$translate',
  '$route',
  '$filter',
  '$cookieStore',
  'Auth',
  'Nav',
  'ProductSubcategories',
  'settings',
  'ModalScrollLock',
  'ngQuickDateDefaults',
  'dateParse',
  function ($rootScope, $location, $translate, $route, $filter, $cookieStore, Auth, Nav, ProductSubcategories, settings, ModalScrollLock, ngQuickDateDefaults, dateParse) {
    ngQuickDateDefaults.parseDateFunction = dateParse.parse;
    $rootScope.basePath = _contextPath;
    $rootScope.version = settings.version;
    var token = $cookieStore.get('token');
    if (token) {
      $rootScope.authToken = token;
      Auth.getUser();
    }
    if (typeof(WebSocket) != "function") {
      $rootScope.noWebSocket = true;
    }

    var systemToken = $cookieStore.get('systemToken');
    if(systemToken){
      $rootScope.system = systemToken;
    }

    $rootScope.logout = Auth.logout;

    $rootScope.lang = $translate.use() || $translate.proposedLanguage() || 'en';
    $rootScope.LANG = $rootScope.lang.toUpperCase();
    moment.lang($rootScope.lang);

    var lastPage;
    Nav.registerCallback(function () {
      $rootScope.activePage = Nav.current();
      if($rootScope.activePage && $rootScope.activePage.system !='ALL'){
        $rootScope.system =rootScope.activePage.system;
      }
      if (lastPage != null && $rootScope.navigation) {
        if (!lastPage.publicAccess) {
          var validPage = Nav.hasAccess();
          if (!validPage) {
            if ($rootScope.user) {
              $location.path("/access_denied");
            } else if ($location.path() !== "/login") {
              $location.path("/login");
            }
          }
        }
        lastPage = null;
      }
    });
    //Kristina tuka se zemaat produktite vo menito
    function loadNavigation() {
      if ($rootScope.authToken) {
        Nav.fetch();
      } else {
        ProductSubcategories.categoryNavigation();
      }
    }

    loadNavigation();


    function isAdminMfaSetupPath(path) {
      return path && path.indexOf('/user/profile') === 0;
    }

    function enforceAdminMfaSetup(user, path) {
      if (user && user.mfaSetupRequired && !isAdminMfaSetupPath(path)) {
        $location.path('/user/profile');
        return true;
      }
      return false;
    }

    function handleNavigation(next, page) {

      var publicAccess = next.$$route && next.$$route.publicAccess || false;

      function checkUserAcces(user) {
        if (enforceAdminMfaSetup(user, $location.path())) {
          return;
        }

        if (!$rootScope.navigation) {
          lastPage = next.$$route;
        } else {



          lastPage = null;
          var validPage = Nav.hasAccess();
          if (!validPage) {
            $location.path("/access_denied");
          }
        }
      }

      if (!publicAccess) {
        if ($rootScope.user) {
          checkUserAcces($rootScope.user);
        } else {
          Auth.getUser(function (user) {
            checkUserAcces(user);
          });
        }

      }
    }


    $rootScope.$on('$routeChangeStart', function (event, next, current) {
      ModalScrollLock.release();
      delete $rootScope.errors;
      var path = $location.path();

      if (next) {
        var page = Nav.current();
        $rootScope.activePage = page;
        if($rootScope.activePage && $rootScope.activePage.system != 'ALL'){
          $rootScope.system = $rootScope.activePage.system;
          console.log('System in routeChangeStart = ' + $rootScope.system);
        }
        handleNavigation(next, page);
      }
    });
  }
]);
